var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-records" },
    _vm._l(_vm.groupedData, function (groupItem, gIndex) {
      return _c(
        "div",
        { key: "group-" + gIndex, staticClass: "group-container" },
        [
          _vm.groupValue.fieldId && groupItem.key && groupItem.key !== "N/A"
            ? _c(
                "div",
                {
                  staticClass: "table-row group-header-row",
                  style: { backgroundColor: _vm.getGroupColor(gIndex) },
                  on: {
                    click: function ($event) {
                      return _vm.toggleGroup(gIndex)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-cell group-header-cell",
                      attrs: { colspan: _vm.visibleFields.length + 1 },
                    },
                    [
                      _c("i", { staticClass: "material-icons group-icon" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.isGroupExpanded(gIndex)
                                ? "expand_more"
                                : "chevron_right"
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(groupItem.key) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isGroupExpanded(gIndex),
                  expression: "isGroupExpanded(gIndex)",
                },
              ],
              staticClass: "group-content",
            },
            [
              _vm._l(groupItem.records, function (record) {
                return _c(
                  "div",
                  {
                    key: record._id,
                    staticClass: "table-row",
                    class: {
                      selected:
                        _vm.isSelectionModeActive && _vm.isSelected(record._id),
                    },
                    style: { backgroundColor: _vm.getRecordColor(record) },
                    attrs: {
                      id: "record-" + record._id,
                      "data-record-id": record._id,
                    },
                    on: {
                      mouseover: function ($event) {
                        !_vm.isSelectionModeActive &&
                          _vm.showCheckbox(record._id)
                      },
                      mouseleave: function ($event) {
                        !_vm.isSelectionModeActive &&
                          _vm.hideCheckbox(record._id)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "table-cell record-id-cell" },
                      [
                        _vm.pickerMode
                          ? [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit(
                                        "record-selected",
                                        record
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Select")]
                              ),
                            ]
                          : [
                              !_vm.isSelectionModeActive &&
                              !_vm.isCheckboxVisible(record._id)
                                ? _c("span", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(record.recordId) +
                                        "\n                        "
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "checkbox-container" },
                                    [
                                      _c("a-checkbox", {
                                        attrs: {
                                          checked: _vm.isSelected(record._id),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit(
                                              "toggle-selection",
                                              record._id
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      !_vm.isSelectionModeActive
                                        ? _c(
                                            "SupsisButton",
                                            {
                                              attrs: { ghost: "", primary: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewRecord(record)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("open_in_new")]
                                              ),
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t("modules.viewRecord")
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.visibleFields, function (field, index) {
                      return _c(
                        "div",
                        {
                          key: field._id,
                          staticClass: "table-cell",
                          class: {
                            active: _vm.isActiveCell(record._id, field._id),
                          },
                          attrs: {
                            tabindex: "0",
                            "data-field-type": field.fieldType,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setActiveCell(record._id, field._id)
                            },
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "tab",
                                    9,
                                    $event.key,
                                    "Tab"
                                  )
                                ) {
                                  return null
                                }
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.moveToNextCell(record._id, index)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.editCell(record._id, field._id)
                              },
                            ],
                          },
                        },
                        [
                          _vm.loading
                            ? _c("LoadingCell", {
                                attrs: { fieldType: field.fieldType },
                              })
                            : [
                                "text",
                                "long-text",
                                "email",
                                "url",
                                "phone",
                              ].includes(field.fieldType)
                            ? _c("StringCell", {
                                ref: "stringCells",
                                refInFor: true,
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "checkbox"
                            ? _c("CheckboxCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "number"
                            ? _c("NumberCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "currency"
                            ? _c("CurrencyCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "dropdown"
                            ? _c("DropdownCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "datetime"
                            ? _c("DateCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "automation-button"
                            ? _c("ButtonCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  tableId: _vm.table._id,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : ["file", "video", "image", "audio"].includes(
                                field.fieldType
                              )
                            ? _c("AssetCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "user"
                            ? _c("UserCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "contact"
                            ? _c("ContactCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "linked-record"
                            ? _c("LinkedRecordCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : field.fieldType === "task"
                            ? _c("TaskCell", {
                                attrs: {
                                  record: record,
                                  field: field,
                                  readonly: _vm.pickerMode,
                                },
                                on: {
                                  "update-record": function ($event) {
                                    return _vm.updateRecord($event)
                                  },
                                },
                              })
                            : _c("div", { staticClass: "table-cell-inner" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.getFieldValue(record, field._id)
                                    ) +
                                    "\n                    "
                                ),
                              ]),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c("TableFooterSummary", {
                attrs: {
                  records: groupItem.records,
                  visibleFields: _vm.visibleFields,
                },
              }),
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }